var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "c-day-planner__day-entry u-extra-medium-padding--bottom",
      class: { box: _vm.isCreateMethod },
    },
    [
      _vm.isUpdateMethod
        ? [
            _c(
              "h2",
              { staticClass: "c-day-planner__day-entry-heading" },
              [
                _vm.entry.project
                  ? [_vm._v(_vm._s(_vm.$t("project")))]
                  : [_vm._v(_vm._s(_vm.$t("tours.name")))],
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "grid-x grid-margin-x" }, [
              _c("div", { staticClass: "cell medium-2" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", [_vm._v(_vm._s(_vm.$t("search.from")))]),
                    _vm._v(" "),
                    _c("v-datepicker", {
                      staticClass:
                        "form-control form-control--small form-control--date",
                      attrs: {
                        placeholder: _vm.$t("search.from"),
                        format:
                          _vm.$t("search.from") + " " + _vm.$helpers.dateFormat,
                        clearButton: true,
                        "monday-first": true,
                        "disabled-dates": _vm.$helpers.disabledDates,
                        language: _vm.de,
                      },
                      model: {
                        value: _vm.entry.startdate,
                        callback: function ($$v) {
                          _vm.$set(_vm.entry, "startdate", $$v)
                        },
                        expression: "entry.startdate",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cell medium-2" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", [_vm._v(_vm._s(_vm.$t("search.till")))]),
                    _vm._v(" "),
                    _c("v-datepicker", {
                      staticClass:
                        "form-control form-control--small form-control--date",
                      attrs: {
                        placeholder: _vm.$t("search.till"),
                        format:
                          _vm.$t("search.till") + " " + _vm.$helpers.dateFormat,
                        clearButton: true,
                        "monday-first": true,
                        "disabled-dates": {
                          days: [6, 0],
                          to: new Date(_vm.entry.startdate),
                        },
                        language: _vm.de,
                      },
                      model: {
                        value: _vm.entry.enddate,
                        callback: function ($$v) {
                          _vm.$set(_vm.entry, "enddate", $$v)
                        },
                        expression: "entry.enddate",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cell medium-2" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { attrs: { for: "form-field-kolonne" } }, [
                      _vm._v(_vm._s(_vm.$t("tours.kolonne"))),
                    ]),
                    _vm._v(" "),
                    _c("v-select-kolonne", {
                      attrs: {
                        id: "form-field-kolonne",
                        name: "kolonne",
                        placeholder: _vm.$t("select"),
                      },
                      model: {
                        value: _vm.entry.kolonne,
                        callback: function ($$v) {
                          _vm.$set(_vm.entry, "kolonne", $$v)
                        },
                        expression: "entry.kolonne",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cell medium-6" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v(_vm._s(_vm.$t("form.upload.comment")))]),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.entry.comment,
                        expression: "entry.comment",
                      },
                    ],
                    attrs: { name: "comment" },
                    domProps: { value: _vm.entry.comment },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.entry, "comment", $event.target.value)
                      },
                    },
                  }),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "grid-x grid-margin-x" }, [
              _c("div", { staticClass: "cell medium-2" }, [
                _vm.entry.project_id
                  ? _c("div", { staticClass: "form-group" }, [
                      _c("label", { staticClass: "text-center" }, [
                        _vm._v(_vm._s(_vm.$t("weeks.project.print_uploads"))),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.entry.print_attachments,
                            expression: "entry.print_attachments",
                          },
                        ],
                        attrs: { type: "checkbox", name: "print_attachments" },
                        domProps: {
                          value: true,
                          checked: Array.isArray(_vm.entry.print_attachments)
                            ? _vm._i(_vm.entry.print_attachments, true) > -1
                            : _vm.entry.print_attachments,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.entry.print_attachments,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = true,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.entry,
                                    "print_attachments",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.entry,
                                    "print_attachments",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.entry, "print_attachments", $$c)
                            }
                          },
                        },
                      }),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cell medium-1" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "text-center" }, [
                    _vm._v(_vm._s(_vm.$t("weeks.project.milling"))),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.entry.milling,
                        expression: "entry.milling",
                      },
                    ],
                    attrs: { type: "checkbox", name: "milling" },
                    domProps: {
                      value: true,
                      checked: Array.isArray(_vm.entry.milling)
                        ? _vm._i(_vm.entry.milling, true) > -1
                        : _vm.entry.milling,
                    },
                    on: {
                      change: [
                        function ($event) {
                          var $$a = _vm.entry.milling,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = true,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.entry,
                                  "milling",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.entry,
                                  "milling",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.entry, "milling", $$c)
                          }
                        },
                        function ($event) {
                          return _vm.updateComment(_vm.entry.milling)
                        },
                      ],
                    },
                  }),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cell medium-2" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "text-center" }, [
                    _vm._v(_vm._s(_vm.$t("weeks.project.is_date_fixed"))),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.entry.is_date_fixed,
                        expression: "entry.is_date_fixed",
                      },
                    ],
                    attrs: { type: "checkbox", name: "is_date_fixed" },
                    domProps: {
                      value: true,
                      checked: Array.isArray(_vm.entry.is_date_fixed)
                        ? _vm._i(_vm.entry.is_date_fixed, true) > -1
                        : _vm.entry.is_date_fixed,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.entry.is_date_fixed,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = true,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.entry,
                                "is_date_fixed",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.entry,
                                "is_date_fixed",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.entry, "is_date_fixed", $$c)
                        }
                      },
                    },
                  }),
                ]),
              ]),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.isCreateMethod
        ? [
            _c("div", { staticClass: "grid-x grid-margin-x" }, [
              _c("div", { staticClass: "cell medium-2" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", [_vm._v(_vm._s(_vm.$t("search.from")))]),
                    _vm._v(" "),
                    _c("v-datepicker", {
                      staticClass:
                        "form-control form-control--small form-control--date",
                      attrs: {
                        placeholder: _vm.$t("search.from"),
                        format:
                          _vm.$t("search.from") + " " + _vm.$helpers.dateFormat,
                        clearButton: true,
                        "monday-first": true,
                        "disabled-dates": _vm.$helpers.disabledDates,
                        language: _vm.de,
                      },
                      model: {
                        value: _vm.startdate,
                        callback: function ($$v) {
                          _vm.startdate = $$v
                        },
                        expression: "startdate",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cell medium-2" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", [_vm._v(_vm._s(_vm.$t("search.till")))]),
                    _vm._v(" "),
                    _c("v-datepicker", {
                      staticClass:
                        "form-control form-control--small form-control--date",
                      attrs: {
                        placeholder: _vm.$t("search.till"),
                        format:
                          _vm.$t("search.till") + " " + _vm.$helpers.dateFormat,
                        clearButton: true,
                        "monday-first": true,
                        "disabled-dates": {
                          days: [6, 0],
                          to: new Date(_vm.startdate),
                        },
                        language: _vm.de,
                      },
                      model: {
                        value: _vm.enddate,
                        callback: function ($$v) {
                          _vm.enddate = $$v
                        },
                        expression: "enddate",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cell medium-2" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { attrs: { for: "form-field-kolonne" } }, [
                      _vm._v(_vm._s(_vm.$t("tours.kolonne"))),
                    ]),
                    _vm._v(" "),
                    _c("v-select-kolonne", {
                      attrs: {
                        id: "form-field-kolonne",
                        name: "kolonne",
                        placeholder: _vm.$t("select"),
                      },
                      model: {
                        value: _vm.kolonne,
                        callback: function ($$v) {
                          _vm.kolonne = $$v
                        },
                        expression: "kolonne",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cell medium-3" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v(_vm._s(_vm.$t("form.upload.comment")))]),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.comment,
                        expression: "comment",
                      },
                    ],
                    attrs: { name: "comment" },
                    domProps: { value: _vm.comment },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.comment = $event.target.value
                      },
                    },
                  }),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cell medium-2" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [
                    _vm._v(_vm._s(_vm.$t("weeks.project.print_uploads"))),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.print_attachments,
                        expression: "print_attachments",
                      },
                    ],
                    attrs: { type: "checkbox", name: "print_attachments" },
                    domProps: {
                      value: true,
                      checked: Array.isArray(_vm.print_attachments)
                        ? _vm._i(_vm.print_attachments, true) > -1
                        : _vm.print_attachments,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.print_attachments,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = true,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              (_vm.print_attachments = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.print_attachments = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.print_attachments = $$c
                        }
                      },
                    },
                  }),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cell medium-1" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [
                    _vm._v(_vm._s(_vm.$t("weeks.project.milling"))),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.milling,
                        expression: "milling",
                      },
                    ],
                    attrs: { type: "checkbox", name: "milling" },
                    domProps: {
                      value: false,
                      checked: Array.isArray(_vm.milling)
                        ? _vm._i(_vm.milling, false) > -1
                        : _vm.milling,
                    },
                    on: {
                      change: [
                        function ($event) {
                          var $$a = _vm.milling,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = false,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.milling = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.milling = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.milling = $$c
                          }
                        },
                        function ($event) {
                          return _vm.updateComment(_vm.milling)
                        },
                      ],
                    },
                  }),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cell medium-1" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [
                    _vm._v(_vm._s(_vm.$t("weeks.project.is_date_fixed"))),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.is_date_fixed,
                        expression: "is_date_fixed",
                      },
                    ],
                    attrs: { type: "checkbox", name: "is_date_fixed" },
                    domProps: {
                      value: false,
                      checked: Array.isArray(_vm.is_date_fixed)
                        ? _vm._i(_vm.is_date_fixed, false) > -1
                        : _vm.is_date_fixed,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.is_date_fixed,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = false,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.is_date_fixed = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.is_date_fixed = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.is_date_fixed = $$c
                        }
                      },
                    },
                  }),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "c-day-planner__search" }, [
              _c(
                "form",
                {
                  staticClass: "filter filter--search",
                  attrs: { action: "", method: "POST", novalidation: "" },
                  on: { submit: _vm.searchProject },
                },
                [
                  _c("div", { staticClass: "grid-x grid-margin-x" }, [
                    _c("div", { staticClass: "cell small-12 medium-4" }, [
                      _c(
                        "div",
                        { staticClass: "form-group form-group--search" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.projectsTableFilter.search,
                                expression: "projectsTableFilter.search",
                              },
                            ],
                            staticClass:
                              "form-control form-control--small form-control--search",
                            attrs: {
                              type: "text",
                              placeholder: _vm.$t("search.project_number"),
                            },
                            domProps: { value: _vm.projectsTableFilter.search },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.projectsTableFilter,
                                  "search",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "button",
                              attrs: {
                                role: "button",
                                type: "submit",
                                title: _vm.$t("search"),
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("search")))]
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]
              ),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.isCreateMethod || _vm.entry.project !== null
        ? _c(
            "div",
            { staticClass: "c-day-planner__table" },
            [
              _c("v-table", {
                attrs: {
                  isLoading: _vm.projectTableLoading,
                  columns: _vm.projectTableColumns,
                  items: _vm.projectTableItem,
                  showHeaderRow: true,
                  showShowAll: false,
                  useDetailRow: false,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "project_number",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "router-link",
                            {
                              staticClass: "table__subtil-link",
                              attrs: {
                                to: {
                                  name: "customers-update-customer-project",
                                  params: {
                                    customer: row.customer_id,
                                    project: row.id,
                                  },
                                },
                                title: _vm.$t("update"),
                              },
                            },
                            [_vm._v(_vm._s(row.project_number))]
                          ),
                          _vm._v(" "),
                          _vm.isCreateMethod
                            ? [
                                _vm.weekplans.length >= 1
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "callout warning text-center",
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "u-extra-small-margin--bottom",
                                          },
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "weeks.message.entryexits.title"
                                                  )
                                                ) + ":"
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.weekplans,
                                          function (weekplan, index) {
                                            return _c("div", { key: index }, [
                                              _c("section", [
                                                _vm._v(
                                                  _vm._s(_vm.$t("date.on")) +
                                                    ": " +
                                                    _vm._s(
                                                      _vm._f("moment")(
                                                        weekplan.startdate,
                                                        "DD.MM.YYYY"
                                                      )
                                                    ) +
                                                    ", " +
                                                    _vm._s(
                                                      _vm.$t("kolonne.title")
                                                    ) +
                                                    ": " +
                                                    _vm._s(weekplan.kolonne)
                                                ),
                                              ]),
                                            ])
                                          }
                                        ),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                              ]
                            : [
                                _vm.weekplans.length >= 2
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "callout warning text-center",
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "u-extra-small-margin--bottom",
                                          },
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "weeks.message.entryexits.title"
                                                  )
                                                ) + ":"
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.weekplans,
                                          function (weekplan, index) {
                                            return _c("div", { key: index }, [
                                              weekplan.id != _vm.entry.id
                                                ? _c("section", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("date.on")
                                                      ) +
                                                        ": " +
                                                        _vm._s(
                                                          _vm._f("moment")(
                                                            weekplan.startdate,
                                                            "DD.MM.YYYY"
                                                          )
                                                        ) +
                                                        ", " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "kolonne.title"
                                                          )
                                                        ) +
                                                        ": " +
                                                        _vm._s(weekplan.kolonne)
                                                    ),
                                                  ])
                                                : _vm._e(),
                                            ])
                                          }
                                        ),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                              ],
                        ]
                      },
                    },
                    {
                      key: "company_name",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "div",
                            { staticClass: "u-extra-small-margin--bottom" },
                            [_vm._v(_vm._s(row.customer.company_name))]
                          ),
                          _vm._v(" "),
                          row.account.profile_id != ""
                            ? _c(
                                "div",
                                { staticClass: "u-extra-small-margin--bottom" },
                                [
                                  _c("strong", [_vm._v(_vm._s(_vm.$t("pms")))]),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(row.account.profile.firstname) +
                                      " " +
                                      _vm._s(row.account.profile.lastname) +
                                      "\n          "
                                  ),
                                  _c("br"),
                                  _vm._v(" "),
                                  row.account.profile.communication.phone
                                    ? _c("div", [
                                        _vm._v(
                                          "Tel.: " +
                                            _vm._s(
                                              row.account.profile.communication
                                                .phone
                                            )
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  row.account.profile.communication.mobile
                                    ? _c("div", [
                                        _vm._v(
                                          "Mobil: " +
                                            _vm._s(
                                              row.account.profile.communication
                                                .mobile
                                            )
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          row.site_contact_info != ""
                            ? _c(
                                "div",
                                { staticClass: "u-extra-small-margin--bottom" },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.$t("customers.contact_person"))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(row.site_contact_info) +
                                      "\n        "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "u-extra-small-margin--bottom" },
                            [
                              _c("strong", [_vm._v("Limit")]),
                              _vm._v(" "),
                              row.location.risk
                                ? [
                                    row.location.risk.decided_budget
                                      ? [
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("location.risk.limit")
                                              ) +
                                                ": " +
                                                _vm._s(
                                                  _vm.$helpers.formateCurrency(
                                                    row.location.risk
                                                      .decided_budget
                                                  )
                                                )
                                            ),
                                          ]),
                                        ]
                                      : [
                                          _c(
                                            "div",
                                            { staticClass: "u-color--alert" },
                                            [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "location.risk.decided_budget.not_exist"
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ],
                                    _vm._v(" "),
                                    row.location.risk.valid_from
                                      ? [
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "location.risk.valid_from"
                                                )
                                              ) +
                                                ": " +
                                                _vm._s(
                                                  _vm._f("moment")(
                                                    row.location.risk
                                                      .valid_from,
                                                    "DD.MM.YYYY"
                                                  )
                                                )
                                            ),
                                          ]),
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    row.location.risk.valid_until
                                      ? [
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "location.risk.valid_until"
                                                )
                                              ) +
                                                ": " +
                                                _vm._s(
                                                  _vm._f("moment")(
                                                    row.location.risk
                                                      .valid_until,
                                                    "DD.MM.YYYY"
                                                  )
                                                )
                                            ),
                                          ]),
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !row.location.risk.is_valid
                                      ? _c(
                                          "div",
                                          { staticClass: "u-color--alert" },
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "location.risk.not_valid"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                : [
                                    _c(
                                      "div",
                                      { staticClass: "u-color--alert" },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "location.risk.no_risk_number"
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ],
                            ],
                            2
                          ),
                        ]
                      },
                    },
                    {
                      key: "address",
                      fn: function ({ row }) {
                        return [
                          _c("strong", [
                            _vm._v(
                              _vm._s(row.address.zipcode) +
                                " " +
                                _vm._s(row.address.city)
                            ),
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "\n        " +
                              _vm._s(row.address.street) +
                              " " +
                              _vm._s(row.address.housenumber) +
                              "\n      "
                          ),
                        ]
                      },
                    },
                    {
                      key: "layers",
                      fn: function ({ row }) {
                        return [
                          _vm._l(row.layers, function (layer) {
                            return [
                              layer.open_qm !== 0
                                ? _c(
                                    "p",
                                    {
                                      staticClass:
                                        "u-extra-small-margin--bottom",
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "c-day-planner__layer-label",
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.scheduleLayers,
                                                expression: "scheduleLayers",
                                              },
                                            ],
                                            staticClass:
                                              "c-day-planner__layer-checkbox",
                                            attrs: { type: "checkbox" },
                                            domProps: {
                                              value: layer.id,
                                              checked: Array.isArray(
                                                _vm.scheduleLayers
                                              )
                                                ? _vm._i(
                                                    _vm.scheduleLayers,
                                                    layer.id
                                                  ) > -1
                                                : _vm.scheduleLayers,
                                            },
                                            on: {
                                              change: function ($event) {
                                                var $$a = _vm.scheduleLayers,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = layer.id,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      (_vm.scheduleLayers =
                                                        $$a.concat([$$v]))
                                                  } else {
                                                    $$i > -1 &&
                                                      (_vm.scheduleLayers = $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        ))
                                                  }
                                                } else {
                                                  _vm.scheduleLayers = $$c
                                                }
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(_vm._s(layer.subtype)),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  )
                                : _c(
                                    "p",
                                    {
                                      staticClass:
                                        "u-extra-small-margin--bottom u-color--success",
                                      attrs: {
                                        title: _vm.$t("status.finished"),
                                      },
                                    },
                                    [_vm._v(_vm._s(layer.subtype))]
                                  ),
                            ]
                          }),
                        ]
                      },
                    },
                    {
                      key: "thickness",
                      fn: function ({ row }) {
                        return [
                          _vm._l(row.layers, function (layer) {
                            return [
                              _c(
                                "p",
                                { staticClass: "u-extra-small-margin--bottom" },
                                [
                                  _c("strong", [
                                    _vm._v(_vm._s(layer.thickness)),
                                  ]),
                                ]
                              ),
                            ]
                          }),
                        ]
                      },
                    },
                    {
                      key: "openqm",
                      fn: function ({ row }) {
                        return [
                          _vm._l(row.layers, function (layer) {
                            return [
                              _c(
                                "p",
                                { staticClass: "u-extra-small-margin--bottom" },
                                [
                                  _c("strong", [_vm._v(_vm._s(layer.open_qm))]),
                                  _vm._v("\n            /\n            "),
                                  _c("span", { staticClass: "u-text-small" }, [
                                    _vm._v(_vm._s(layer.qm)),
                                  ]),
                                ]
                              ),
                            ]
                          }),
                        ]
                      },
                    },
                    {
                      key: "tons",
                      fn: function ({ row }) {
                        return [
                          _vm._l(row.layers, function (layer) {
                            return [
                              _c(
                                "p",
                                { staticClass: "u-extra-small-margin--bottom" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "c-day-planner__tons-label",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("calcTons")(
                                            layer.open_qm,
                                            layer.thickness
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          }),
                        ]
                      },
                    },
                    {
                      key: "tok",
                      fn: function ({ row }) {
                        return [
                          row.layer_tok
                            ? _c("span", [_vm._v(_vm._s(_vm.$t("yes")))])
                            : _c("span", { staticClass: "u-error" }, [
                                _vm._v(_vm._s(_vm.$t("no"))),
                              ]),
                        ]
                      },
                    },
                    {
                      key: "deadline",
                      fn: function ({ row }) {
                        return [
                          row.earliest_start
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$helpers.formatEarliestStartLabel(
                                      row.earliest_start
                                    )
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          row.earliest_start_comment
                            ? _c("span", [
                                _vm._v(
                                  " " + _vm._s(row.earliest_start_comment)
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !row.earliest_start_comment && row.requested_deadline
                            ? _c("span", [
                                _vm._v(" " + _vm._s(row.requested_deadline)),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: "uploads",
                      fn: function ({ row }) {
                        return [
                          row.uploads.length > 0
                            ? [
                                _c(
                                  "router-link",
                                  {
                                    staticClass:
                                      "button button--action button--action--files button--small",
                                    attrs: {
                                      to: {
                                        name: "customers-view-customer-project-media",
                                        params: {
                                          customer: row.customer_id,
                                          project: row.id,
                                        },
                                      },
                                      title: _vm.$t("media"),
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("media")))]
                                ),
                              ]
                            : [_vm._v(_vm._s(_vm.$t("no")))],
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1547174531
                ),
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isUpdateMethod
        ? [
            _vm.entry.tour !== null
              ? _c("div", [
                  _c(
                    "p",
                    { staticClass: "u-no-margin u-extra-small-margin--bottom" },
                    [
                      _c("span", { staticClass: "h5" }, [
                        _vm._v(_vm._s(_vm.$t("tours.tournumber")) + ":"),
                      ]),
                      _vm._v(" "),
                      _c("strong", [
                        _vm._v(_vm._s(_vm.entry.tour.tour_number)),
                      ]),
                    ]
                  ),
                ])
              : _vm._e(),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.currentProject.site_comments
        ? _c("div", [
            _c("p", [
              _c("strong", [_vm._v(_vm._s(_vm.$t("form.comments.comment")))]),
              _vm._v(" "),
              _c("br"),
              _vm._v(
                "\n      " + _vm._s(_vm.currentProject.site_comments) + "\n    "
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isUpdateMethod
        ? [
            _vm.entry.project
              ? _c(
                  "div",
                  {
                    staticClass:
                      "c-day-planner__mixing-plants grid-x grid-margin-x u-extra-small-margin--bottom",
                  },
                  [
                    _c("div", { staticClass: "cell small-12" }, [
                      _c("p", { staticClass: "u-extra-small-margin--bottom" }, [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.$t("tours.mixingplants"))),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "cell small-auto medium-3" }, [
                      _c(
                        "a",
                        {
                          staticClass: "button secondary small",
                          attrs: { title: _vm.$t("insert") },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.openMixingPlantSearch(
                                _vm.entry.project.address.zipcode,
                                "0"
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("tours.mixingplants")) +
                              " " +
                              _vm._s(_vm.$t("insert"))
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "cell small-auto medium-9" },
                      [
                        _vm.mixingPlantResultsTableItemsSelected.length == 0
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "callout warning text-center callout--over-table",
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("weeks.warning.nomixingplant"))
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("v-table", {
                          attrs: {
                            isLoading: _vm.mixingPlantTableLoading,
                            columns: _vm.mixingPlantTableColumns,
                            items: _vm.mixingPlantTableItems,
                            showHeaderRow: false,
                            showShowAll: false,
                            useDetailRow: false,
                            reloadTable: _vm.mixingPlantReloadTable,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "company_name",
                                fn: function ({ row }) {
                                  return [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "u-extra-small-margin--bottom",
                                      },
                                      [
                                        _c("span", {
                                          staticClass: "c-ranking",
                                          class: _vm.rankingClass(row.ranking),
                                        }),
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(row.name) +
                                            "\n            "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    row.phone
                                      ? _c(
                                          "p",
                                          { staticClass: "u-no-margin" },
                                          [_vm._v("Tel.: " + _vm._s(row.phone))]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                              {
                                key: "address",
                                fn: function ({ row }) {
                                  return [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "u-extra-small-margin--bottom",
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(row.address.zipcode) +
                                              " " +
                                              _vm._s(row.address.city)
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(row.address.street) +
                                          " " +
                                          _vm._s(row.address.housenumber)
                                      ),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "comment",
                                fn: function ({ row }) {
                                  return [
                                    _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: row.comment,
                                          expression: "row.comment",
                                        },
                                      ],
                                      domProps: { value: row.comment },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            row,
                                            "comment",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "delete",
                                fn: function ({ row }) {
                                  return [
                                    _c("label", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.mixingPlantResultsTableItemsSelected,
                                            expression:
                                              "mixingPlantResultsTableItemsSelected",
                                          },
                                        ],
                                        attrs: {
                                          type: "checkbox",
                                          name: "mixing_plants_selected[]",
                                        },
                                        domProps: {
                                          value: row.id,
                                          checked: Array.isArray(
                                            _vm.mixingPlantResultsTableItemsSelected
                                          )
                                            ? _vm._i(
                                                _vm.mixingPlantResultsTableItemsSelected,
                                                row.id
                                              ) > -1
                                            : _vm.mixingPlantResultsTableItemsSelected,
                                        },
                                        on: {
                                          change: function ($event) {
                                            var $$a =
                                                _vm.mixingPlantResultsTableItemsSelected,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = row.id,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  (_vm.mixingPlantResultsTableItemsSelected =
                                                    $$a.concat([$$v]))
                                              } else {
                                                $$i > -1 &&
                                                  (_vm.mixingPlantResultsTableItemsSelected =
                                                    $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ))
                                              }
                                            } else {
                                              _vm.mixingPlantResultsTableItemsSelected =
                                                $$c
                                            }
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("i"),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            128383079
                          ),
                        }),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("v-mixing-plant-search-modal", {
        attrs: {
          isVisible: _vm.mixingPlantSearchModal.isVisible,
          zipcode: _vm.mixingplantZipcode,
          rowUid: _vm.mixingplantRowUid,
        },
        on: { addMixingplantsToRoute: _vm.addMixingplantsFromModal },
        model: {
          value: _vm.mixingPlantSearchModal.isVisible,
          callback: function ($$v) {
            _vm.$set(_vm.mixingPlantSearchModal, "isVisible", $$v)
          },
          expression: "mixingPlantSearchModal.isVisible",
        },
      }),
      _vm._v(" "),
      _vm.isUpdateMethod
        ? [
            _c("div", { staticClass: "grid-x grid-margin-x" }, [
              _c("div", { staticClass: "cell small-auto medium-9" }, [
                _c(
                  "button",
                  {
                    staticClass: "button button--action--save",
                    attrs: {
                      role: "button",
                      title: _vm.$t("form.submit.save"),
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.updateEntry.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("form.submit.save")))]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "cell small-auto medium-3 text-right" },
                [
                  _vm.entry.tour !== null
                    ? _c(
                        "div",
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "button gray",
                              attrs: {
                                to: {
                                  name: "update-tour",
                                  params: { tour: _vm.entry.tour_id },
                                },
                                title: _vm.$t("update"),
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("tours.update.title")))]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.entry.project
                    ? _c("div", [
                        _c(
                          "button",
                          {
                            staticClass: "button gray",
                            attrs: { role: "button", title: _vm.$t("delete") },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.triggerDeleteModal.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("delete")))]
                        ),
                      ])
                    : _vm._e(),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("v-dialog", {
              attrs: {
                isVisible: _vm.isVisible,
                messageType: _vm.messageType,
                content: _vm.dialogContent,
              },
              on: { deleteEntry: _vm.handleDelete },
              model: {
                value: _vm.isVisible,
                callback: function ($$v) {
                  _vm.isVisible = $$v
                },
                expression: "isVisible",
              },
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.isCreateMethod
        ? [
            _c("div", { staticClass: "grid-x grid-margin-x" }, [
              _c(
                "div",
                { staticClass: "cell auto" },
                [
                  _vm.currentProject.length !== 0
                    ? [
                        _c(
                          "button",
                          {
                            staticClass: "button",
                            attrs: {
                              role: "button",
                              type: "submit",
                              title: _vm.$t("form.submit.insert"),
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.createEntry.apply(null, arguments)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("form.submit.insert")))]
                        ),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "button gray",
                      attrs: { role: "button", title: _vm.$t("cancel") },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.cancelEntry.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("cancel")))]
                  ),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("v-dialog", {
              attrs: {
                isVisible: _vm.isVisible,
                messageType: _vm.messageType,
                content: _vm.dialogContent,
              },
              model: {
                value: _vm.isVisible,
                callback: function ($$v) {
                  _vm.isVisible = $$v
                },
                expression: "isVisible",
              },
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }